import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import { Container, Card, Tab, Nav } from 'react-bootstrap';
import Swal from 'sweetalert2';

import { getConfiguration } from 'apis/admin/configApi';

import SimpleHeader from 'components/Headers/SimpleHeader';
import BasicSetting from './BasicSetting';
import CompanyInfo from './CompanyInfo';

// 환경 설정 탭 배열
const tabList = [
  {
    idx: 1,
    eventKey: 'basic',
    name: '기본 정보',
  },
  {
    idx: 2,
    eventKey: 'company',
    name: '회사 정보',
  },
];

// 기본 정보 meta key
const basicMetaKey = [
  'site_title',
  'site_logo',
  'admin_logo',
  'footer_script',
  'spam_word',
  'max_level',
  'receive_email',
];

// 회사 정보 meta key
const infoMetaKey = [
  'company_name',
  'company_reg_no',
  'company_owner',
  'company_phone',
  'company_fax',
  'company_retail_sale_no',
  'company_added_sale_no',
  'company_zipcode',
  'company_address',
  'company_address_detail',
  'company_admin_name',
  'company_admin_email',
];

function Index() {
  const user = useSelector(state => state.user);

  const [allConfig, setAllConfig] = useState([]);   // 모든 환경 설정값
  const [basic, setBasic] = useState({});           // 기본 정보
  const [company, setCompany] = useState({});       // 회사 정보

  // 환경 설정값 불러오기
  const getAllConfiguration = async () => {
    setAllConfig([]);
    setBasic([]);
    setCompany([]);
    
    await getConfiguration()
      .then(response => {
        if (response.data.success) {
          setAllConfig(response.data.result);
        } else {
          Swal.fire({
            icon: 'error',
            title: '환경 설정을 불러올 수 없습니다.',
            text: '잠시 후 다시 시도해주세요.',
          }).then(() => {
            return;
          });
        }
      })
      .catch(error => {
        console.error('error occured in BasicConfig/Index.js - getAllConfiguration() ', error);

        Swal.fire({
          icon: 'error',
          title: '환경 설정을 불러올 수 없습니다.',
          text: '잠시 후 다시 시도해주세요.',
        }).then(() => {
          return;
        });
      });
  };

  // 기본 정보 state에 세팅
  const settingBasicState = () => {
    const tempObj = {};

    allConfig.forEach(element1 => {
      basicMetaKey.forEach(element2 => {
        if (element1.key === element2) {
          tempObj[element2] = element1.value;
        }
      });
    });
    
    setBasic(tempObj);
  };

  // 회사 정보 state에 세팅
  const settingCompanyInfoState = () => {
    const tempObj = {};

    allConfig.forEach(element1 => {
      infoMetaKey.forEach(element2 => {
        if (element1.key === element2) {
          tempObj[element2] = element1.value;
        }
      });
    });
    
    setCompany(tempObj);
  };

  useEffect(() => {
    getAllConfiguration();
  }, []);

  useEffect(() => {
    settingBasicState();
    settingCompanyInfoState();
  }, [allConfig]);

  return (
    <div>
      <SimpleHeader parentName="환경 설정" name="기본 환경 설정" />
      <Container className="mt--6" fluid>
        <Tab.Container
          id="left-tabs-example"
          defaultActiveKey={tabList[0].eventKey}
          transition={false}
        >
          <Card>
            <Card.Header>
              <Nav
                variant="tabs"
                className="flex-row"
                defaultActiveKey={tabList[0].eventKey}
              >
                {tabList.map((tab) => {
                  return (
                    <Nav.Item key={tab.idx + tab.eventKey}>
                      <Nav.Link eventKey={tab.eventKey} className="px-4 py-2 text-sm">
                        {tab.name}
                      </Nav.Link>
                    </Nav.Item>
                  );
                })}
              </Nav>
            </Card.Header>
            <Card.Body>
              <div className="pl-lg-4 pr-lg-4 pt-4">
                <Tab.Content>
                  <BasicSetting
                    configData={basic}
                    getAllConfiguration={getAllConfiguration}
                    tabEventKey={tabList[0].eventKey}
                  />
                  <CompanyInfo
                    configData={company}
                    getAllConfiguration={getAllConfiguration}
                    tabEventKey={tabList[1].eventKey}
                  />
                </Tab.Content>
              </div>
            </Card.Body>
          </Card>
        </Tab.Container>
      </Container>
    </div>
  );
}

export default Index;
